<template>
  <el-dialog
    :visible="visible"
    fullscreen
    append-to-body
    @close="$emit('close')"
  >
    <img width="100%" :src="url" alt="" />
  </el-dialog>
</template>

<script>
export default {
  name: 'ImgViewer',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
  },
}
</script>
